/* UNVEXT Sponsorship Program page — scoped behavior.
   Loads only from sections/sponsorship-program.liquid (defer).
   Everything lives in one IIFE; the single global is
   window.unvxtSpTrackEvent (analytics stub, real provider wired later). */
(function () {
  'use strict';

  /* The page is split into sponsorship-* sections that each load this file —
     run the whole script exactly once (flag lives on <html>, not a global) */
  if (document.documentElement.hasAttribute('data-unvxt-sp-booted')) return;
  document.documentElement.setAttribute('data-unvxt-sp-booted', '');

  /* Analytics stub — the one permitted global */
  if (typeof window.unvxtSpTrackEvent !== 'function') {
    window.unvxtSpTrackEvent = function (name) {
      console.log('[unvxt-sp analytics]', name);
    };
  }
  var track = window.unvxtSpTrackEvent;

  function init() {
    var root = document.querySelector('.unvxt-sp-root');
    if (!root) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* --- #apply must exist wherever the application currently lives ---
       The application section can be enabled or disabled from the Customizer,
       and the five Apply CTAs point at #apply either way. Both states used to
       be handled by hand: sponsorship-cta.liquid carried a stand-in id while
       the form was off, and a comment asked whoever re-enabled the form to
       remove it. Both halves of that have now failed in production — first a
       duplicate, when the form was enabled and the stand-in was left behind,
       which sent every CTA to the band because it renders first; then none at
       all, when the stand-in was removed and the form was later disabled,
       leaving all five buttons scrolling nowhere.

       So the anchor is claimed at runtime instead: take it for the CTA band
       only when nothing else has it. Neither state can produce a duplicate,
       and neither can produce none. */
    if (!document.getElementById('apply')) {
      var ctaFallback = document.querySelector('.unvxt-sp-cta-band');
      if (ctaFallback) ctaFallback.id = 'apply';
    }

    track('page_view');

    /* --- Apply CTA clicks (hero, pill nav, path cards, final band) --- */
    document.querySelectorAll('[data-sp-cta]').forEach(function (el) {
      el.addEventListener('click', function () { track('cta_click'); });
    });

    /* --- Program blocks: pill tabs + reading state --- */
    var pillTabs = Array.prototype.slice.call(document.querySelectorAll('[data-sp-block]'));
    var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-sp-index]'));

    function setActivePill(i) {
      pillTabs.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
      /* Mark the block itself too, so the reader gets a "you are here" rail in
         the copy and not only in the pill row. Every caller routes through
         here — which is now just the scrollspy, at every breakpoint. */
      blocks.forEach(function (b, j) { b.classList.toggle('is-reading', j === i); });
    }

    /* --- Smooth anchor scrolling (anchor offsets handled by the stylesheet).
           The program pills now scroll vertically on every breakpoint. Mobile
           used to steer a horizontal carousel from here via glideToBlock();
           that carousel is gone — the blocks are a vertical scroll-snap — so
           the special case and the glide helper went with it. --- */
    document.querySelectorAll('[data-sp-anchor]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href');
        if (!id || id.charAt(0) !== '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
        history.replaceState(null, '', id);
      });
    });

    if (blocks.length) {
      /* Scrollspy — highlight the pill for the block crossing the middle.
         This runs on every breakpoint now. It used to bail out on mobile
         because a horizontal scroll listener on the track owned the active
         pill there; with the track no longer a scroller, that listener would
         never fire again and the pills would have gone dead on phones. */
      if ('IntersectionObserver' in window) {
        var spy = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) setActivePill(blocks.indexOf(en.target));
          });
        }, { rootMargin: '-45% 0px -45% 0px' });
        blocks.forEach(function (b) { spy.observe(b); });
      }
    }

    /* --- Hide the floating Apply chip while the form itself is on screen --- */
    var applyBar = document.querySelector('.unvxt-sp-applybar');
    var applySection = document.getElementById('apply');
    if (applyBar && applySection && 'IntersectionObserver' in window) {
      var chipIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          applyBar.classList.toggle('unvxt-sp-applybar--hidden', en.isIntersecting);
        });
      }, { threshold: 0.05 });
      chipIo.observe(applySection);
    }

    /* --- Numbers count up whenever they enter view ---
       Not stats-only and not once: the payout statement's figures opt in with
       the same attribute, and the observer below replays on every entry. */
    var countEls = Array.prototype.slice.call(document.querySelectorAll('[data-sp-count]'));
    if (countEls.length && !reducedMotion && 'IntersectionObserver' in window) {
      /* One formatted number, not a run of digits. Splitting on /(\d+)/ tore
         "$1,548.28" into "1" / "548" / "28" and eased each separately, which
         rendered frames like "$0,110.6" — a comma after a zero, on a money
         figure. Keeping the separators and decimals attached lets the whole
         value tween and be re-formatted each frame instead. */
      /* Two timings, chosen per element by the attribute's value.

         The stats band is a punchy headline and stays as it was. The payout
         statement is a document tallying up, and reads better slow.

         "slow" softens the curve as well as lengthening it, which is the part
         that actually matters: cubic ease-out front-loads hard — at 2400ms it
         has already landed 58% of the value in the first 600ms — so raising
         only the duration buys an invisible crawl at the end rather than a
         slower-looking count. Quadratic spreads the movement across the run
         and still eases to a stop instead of halting dead. */
      var SP_TIMING = {
        'default': { dur: 2400, ease: function (t) { return 1 - Math.pow(1 - t, 3); } },
        'slow':    { dur: 5000, ease: function (t) { return 1 - Math.pow(1 - t, 2); } }
      };
      var SP_NUM = /(\d[\d,]*(?:\.\d+)?)/;
      var spIsNum = function (tok) { return /^\d[\d,]*(?:\.\d+)?$/.test(tok); };
      var spValue = function (tok) { return parseFloat(tok.replace(/,/g, '')); };
      /* Re-derive grouping from the source string rather than toLocaleString,
         so the output matches what the page author typed at every locale. */
      var spFormat = function (n, decimals, grouped) {
        var out = n.toFixed(decimals);
        if (!grouped) return out;
        var parts = out.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
      };
      /* The original numeral text is kept on data-sp-raw so the animation can
         replay cleanly every time the band re-enters the viewport */
      countEls.forEach(function (el) { el.setAttribute('data-sp-raw', el.textContent); });
      var runCount = function (el) {
        if (el._spRaf) cancelAnimationFrame(el._spRaf);
        var raw = el.getAttribute('data-sp-raw');
        var tokens = raw.split(SP_NUM);
        /* Nothing to count (e.g. "$0"): hop instead of ticking */
        var hasCountable = tokens.some(function (tok) {
          return spIsNum(tok) && spValue(tok) > 0;
        });
        if (!hasCountable) {
          el.classList.remove('unvxt-sp-hop');
          void el.offsetWidth; /* restart the CSS animation */
          el.classList.add('unvxt-sp-hop');
          return;
        }
        /* Shape of each number is read once, not re-parsed every frame. */
        var shapes = tokens.map(function (tok) {
          if (!spIsNum(tok)) return null;
          return {
            value: spValue(tok),
            decimals: (tok.split('.')[1] || '').length,
            grouped: tok.indexOf(',') !== -1
          };
        });
        /* A bare attribute returns "", which is not a profile name, so the
           stats band falls through to the default without needing a value. */
        var profile = SP_TIMING[el.getAttribute('data-sp-count')];
        /* Checked for dur rather than truthiness: a value like "constructor"
           resolves up the prototype chain to a function, which is truthy and
           has no ease(). A typo in the attribute falls back instead of
           throwing mid-animation. */
        var timing = (profile && profile.dur) ? profile : SP_TIMING['default'];
        var startTs = null;
        var dur = timing.dur;
        var frame = function (ts) {
          if (startTs === null) startTs = ts;
          var t = Math.min(1, (ts - startTs) / dur);
          var ease = timing.ease(t);
          el.textContent = tokens.map(function (tok, i) {
            var shape = shapes[i];
            return shape ? spFormat(shape.value * ease, shape.decimals, shape.grouped) : tok;
          }).join('');
          if (t < 1) { el._spRaf = requestAnimationFrame(frame); }
          else { el._spRaf = null; el.textContent = raw; }
        };
        el._spRaf = requestAnimationFrame(frame);
      };
      var armCountObserver = function () {
        var countIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var el = en.target;
            if (en.isIntersecting) {
              /* Play on every entry, but not while already visible/running */
              if (el.getAttribute('data-sp-counting') !== '1') {
                el.setAttribute('data-sp-counting', '1');
                runCount(el);
              }
            } else {
              /* Left the viewport: reset so the next entry replays */
              el.removeAttribute('data-sp-counting');
              el.classList.remove('unvxt-sp-hop');
              if (el._spRaf) { cancelAnimationFrame(el._spRaf); el._spRaf = null; }
              el.textContent = el.getAttribute('data-sp-raw');
            }
          });
        }, { threshold: 0.5 });
        countEls.forEach(function (el) { countIo.observe(el); });
      };
      /* Arm only once the visitor scrolls — if the band sits in the first
         viewport, the numbers hold until scrolling begins instead of playing
         on page load. Landing mid-page (deep link) counts as scrolled. */
      if ((window.scrollY || 0) > 40) {
        armCountObserver();
      } else {
        window.addEventListener('scroll', armCountObserver, { once: true, passive: true });
      }
    }

    /* --- Hero topographic backdrop: nested contour loops + crosshair marks,
           generated once as SVG (matches the reference topo-map look) --- */
    var topoHost = document.querySelector('[data-sp-topo]');
    if (topoHost && topoHost.children.length === 0) {
      var NS = 'http://www.w3.org/2000/svg';
      var TW = 1600;
      var TH = 900;
      var topoSvg = document.createElementNS(NS, 'svg');
      topoSvg.setAttribute('viewBox', '0 0 ' + TW + ' ' + TH);
      topoSvg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
      var trand = function (min, max) { return min + Math.random() * (max - min); };

      /* The contour lines were literal white and literal blue, from when this
         page was ink-black. Read the ink and accent off the stylesheet instead,
         so the palette lives in exactly one place and a token change carries
         here without a JS edit. The alphas dropped hard in the same move:
         white at 0.6 on near-black is a whisper, ink at 0.6 on paper is a
         drawing — 0.16/0.09 puts the texture back where it belongs. */
      var spStyle = getComputedStyle(root);
      var topoRGB = (spStyle.getPropertyValue('--sp-topo-rgb') || '13, 12, 10').trim();
      var accentRGB = (spStyle.getPropertyValue('--sp-accent-rgb') || '176, 136, 40').trim();
      function topoStroke(a) { return 'rgba(' + topoRGB + ',' + a + ')'; }
      function accentStroke(a) { return 'rgba(' + accentRGB + ',' + a + ')'; }

      /* Peaks on a jittered grid: one contour family per cell, sized to fill
         the cell and just meet its neighbors — dense coverage with no big
         blank patches and no families crossing (matches the reference map) */
      var cols = 5;
      var rows = 3;
      var cellW = TW / cols;
      var cellH = TH / rows;
      for (var gx = 0; gx < cols; gx++) {
        for (var gy = 0; gy < rows; gy++) {
          var cx = (gx + 0.5) * cellW + trand(-cellW * 0.18, cellW * 0.18);
          var cy = (gy + 0.5) * cellH + trand(-cellH * 0.18, cellH * 0.18);
          var rings = 5 + Math.floor(trand(0, 4));
          var maxR = Math.min(cellW, cellH) * trand(0.52, 0.68);
          var rot = trand(0, Math.PI);
          var squish = trand(0.68, 0.95);
          var m1 = Math.floor(trand(2, 4));
          var m2 = Math.floor(trand(4, 7));
          var a1 = trand(0.16, 0.32);
          var a2 = trand(0.06, 0.16);
          var ph1 = trand(0, 6.283);
          var ph2 = trand(0, 6.283);
          var cosR = Math.cos(rot);
          var sinR = Math.sin(rot);
          for (var k = 1; k <= rings; k++) {
            var r = maxR * (k / rings);
            var d = '';
            var steps = 56;
            for (var si = 0; si <= steps; si++) {
              var a = (si / steps) * Math.PI * 2;
              var rr = r * (1 + a1 * Math.sin(a * m1 + ph1) + a2 * Math.sin(a * m2 + ph2));
              var ex = Math.cos(a) * rr;
              var ey = Math.sin(a) * rr * squish;
              var x = cx + ex * cosR - ey * sinR;
              var y = cy + ex * sinR + ey * cosR;
              d += (si === 0 ? 'M' : 'L') + x.toFixed(1) + ' ' + y.toFixed(1) + ' ';
            }
            d += 'Z';
            var tp = document.createElementNS(NS, 'path');
            tp.setAttribute('d', d);
            tp.setAttribute('fill', 'none');
            tp.setAttribute('stroke', topoStroke(k === rings ? 0.16 : 0.09));
            tp.setAttribute('stroke-width', (k === rings ? 1.2 : 0.6).toFixed(1));
            topoSvg.appendChild(tp);
          }
        }
      }

      /* Sparse surveyor crosshairs, like the reference */
      for (var cM = 0; cM < 3; cM++) {
        var mx = trand(150, TW - 150);
        var my = trand(120, TH - 120);
        var len = trand(50, 100);
        var ch = document.createElementNS(NS, 'path');
        ch.setAttribute('d', 'M' + (mx - len).toFixed(0) + ' ' + my.toFixed(0) + ' L' + (mx + len).toFixed(0) + ' ' + my.toFixed(0) +
          ' M' + mx.toFixed(0) + ' ' + (my - len).toFixed(0) + ' L' + mx.toFixed(0) + ' ' + (my + len).toFixed(0));
        ch.setAttribute('fill', 'none');
        ch.setAttribute('stroke', accentStroke(0.45));
        ch.setAttribute('stroke-width', '1');
        topoSvg.appendChild(ch);
      }

      topoHost.appendChild(topoSvg);
    }

    /* --- Entrance fades --- */
    var fades = document.querySelectorAll('.unvxt-sp-fade');
    if (reducedMotion || !('IntersectionObserver' in window)) {
      fades.forEach(function (el) { el.classList.add('unvxt-sp-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('unvxt-sp-in');
            io.unobserve(entry.target);
          }
        });
      });
      fades.forEach(function (el) { io.observe(el); });
    }

    /* --- Post-back landing: Shopify reloads the page after a contact-form
           post; if a confirmation or error state rendered, land on it --- */
    var postback = document.querySelector('[data-sp-postback]');
    if (postback) {
      var apply = document.getElementById('apply');
      if (apply) apply.scrollIntoView({ behavior: 'auto' });
    }

    /* --- Earn: tap a flyer to read it full-size ---------------------------
       The four Earn images are dense text flyers, unreadable at section size.
       A native <dialog> gives the top layer, Esc-to-close, a focus trap and an
       inert background for free — no scroll-lock hacks beyond overflow:hidden.
       Scoped to .unvxt-sp-earn on purpose: .unvxt-sp-media--filled is also used
       by the hero and program sections, and it wraps <video> as well as <img>.
       The page viewport has no maximum-scale, so pinch-zoom works inside the
       dialog on mobile; on desktop, clicking the image toggles a 1:1 scrollable
       view instead. Runs before the form block below, which returns early. --- */
    var earnImgs = Array.prototype.slice.call(
      document.querySelectorAll('.unvxt-sp-earn .unvxt-sp-media--filled img')
    );
    if (earnImgs.length && !document.getElementById('unvxt-sp-zoom')) {
      buildEarnZoom(earnImgs);
    }

    function buildEarnZoom(imgs) {
      var only = imgs.length <= 1;
      var dlg = document.createElement('dialog');
      dlg.id = 'unvxt-sp-zoom';
      dlg.className = 'unvxt-sp-zoom';
      dlg.setAttribute('aria-label', 'Program detail image');
      dlg.innerHTML =
        '<div class="unvxt-sp-zoom__stage" data-zoom-stage>' +
          '<img class="unvxt-sp-zoom__img" alt="" data-zoom-img>' +
        '</div>' +
        '<button type="button" class="unvxt-sp-zoom__close" data-zoom-close aria-label="Close image">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<button type="button" class="unvxt-sp-zoom__nav unvxt-sp-zoom__nav--prev" data-zoom-prev aria-label="Previous image">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>' +
        '</button>' +
        '<button type="button" class="unvxt-sp-zoom__nav unvxt-sp-zoom__nav--next" data-zoom-next aria-label="Next image">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>' +
        '</button>' +
        '<p class="unvxt-sp-zoom__counter" data-zoom-counter aria-live="polite"></p>';
      document.body.appendChild(dlg);

      var stage = dlg.querySelector('[data-zoom-stage]');
      var big = dlg.querySelector('[data-zoom-img]');
      var counter = dlg.querySelector('[data-zoom-counter]');
      var prev = dlg.querySelector('[data-zoom-prev]');
      var next = dlg.querySelector('[data-zoom-next]');
      var closeBtn = dlg.querySelector('[data-zoom-close]');
      var idx = 0;
      var lastTrigger = null;

      if (only) {
        prev.style.display = 'none';
        next.style.display = 'none';
        counter.style.display = 'none';
      }

      /* Shopify CDN srcset tops out at 1200 here — ask for 2400 so the flyer
         text is actually legible when blown up. */
      function highRes(el) {
        var src = el.currentSrc || el.src || '';
        return src.replace(/([?&])width=\d+/, '$1width=2400');
      }

      function show(i) {
        idx = ((i % imgs.length) + imgs.length) % imgs.length;
        dlg.classList.remove('is-zoomed');
        if (stage) stage.scrollTop = stage.scrollLeft = 0;
        big.src = highRes(imgs[idx]);
        big.alt = imgs[idx].alt || '';
        if (counter) counter.textContent = (idx + 1) + ' / ' + imgs.length;
      }

      function openZoom(i, trigger) {
        lastTrigger = trigger || null;
        show(i);
        document.body.classList.add('unvxt-sp-zoom-open');
        if (typeof dlg.showModal === 'function') dlg.showModal();
        else dlg.setAttribute('open', '');
      }

      function closeZoom() {
        if (typeof dlg.close === 'function' && dlg.open) dlg.close();
        else dlg.removeAttribute('open');
      }

      /* Fires for the close button, Esc and form-method=dialog alike */
      dlg.addEventListener('close', function () {
        document.body.classList.remove('unvxt-sp-zoom-open');
        dlg.classList.remove('is-zoomed');
        if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      });

      closeBtn.addEventListener('click', closeZoom);
      prev.addEventListener('click', function () { show(idx - 1); });
      next.addEventListener('click', function () { show(idx + 1); });

      /* Click the empty stage to dismiss; clicking the image toggles 1:1 */
      stage.addEventListener('click', function (e) {
        if (e.target === stage) closeZoom();
      });
      big.addEventListener('click', function (e) {
        e.stopPropagation();
        dlg.classList.toggle('is-zoomed');
      });

      dlg.addEventListener('keydown', function (e) {
        if (only) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
      });

      imgs.forEach(function (el, i) {
        el.classList.add('unvxt-sp-media__zoomable');
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.setAttribute('aria-label', (el.alt || 'Program image') + ' — view full size');

        /* On mobile the Earn blocks live in a horizontal snap carousel, so a
           swipe would otherwise register as a tap. Only open if the pointer
           barely moved. */
        var downX = 0, downY = 0;
        el.addEventListener('pointerdown', function (e) {
          downX = e.clientX; downY = e.clientY;
        });
        el.addEventListener('click', function (e) {
          if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) return;
          e.preventDefault();
          openZoom(i, el);
        });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            openZoom(i, el);
          }
        });
      });
    }

    /* --- Application form --- */
    var form = document.getElementById('unvxt-sp-application');
    if (!form || !form.querySelector('[data-sp-submit]')) return; // confirmation state has no fields

    var submitBtn = form.querySelector('[data-sp-submit]');
    var honeypot = form.querySelector('[data-sp-honeypot]');
    var gates = form.querySelectorAll('[data-sp-gate]');
    var whyField = form.querySelector('[data-sp-why]');
    var counter = form.querySelector('[data-sp-counter]');
    var formStarted = false;
    var submitting = false;

    /* form_start — once, on first focus of any field */
    form.addEventListener('focusin', function (e) {
      if (formStarted) return;
      if (e.target === honeypot) return;
      if (!e.target.matches('input, select, textarea')) return;
      formStarted = true;
      track('form_start');
    });

    /* 300-character live counter (utility face) */
    function updateCounter() {
      if (!whyField || !counter) return;
      counter.textContent = whyField.value.length + ' / ' + (whyField.getAttribute('maxlength') || 300);
    }
    if (whyField) {
      whyField.addEventListener('input', updateCounter);
      updateCounter();
    }

    /* Validity: native constraint check (required fields, email format,
       both checkboxes via required) — submit stays disabled until it passes */
    function checkboxesOk() {
      var ok = true;
      gates.forEach(function (cb) { if (!cb.checked) ok = false; });
      return ok;
    }
    /* The submit button intentionally stays ENABLED even while the form is
       incomplete. Disabling it fires no submit event, so reportValidity()
       below never runs and the applicant is left with a dead, greyed-out
       button and no clue which field is wrong. A single OPTIONAL type="url"
       sample link typed as "instagram.com/x" (no scheme) was enough to
       silently kill the button for the whole form. Validation now happens on
       submit, where the browser scrolls to and labels the offending field. */
    submitBtn.disabled = false;

    /* Reliable capture: mirror the submission into Klaviyo (client events API —
       same public key/pattern as the waitlist) so every application is stored
       as a searchable profile and fires a metric a flow can notify the team
       from. The native Shopify contact post still runs as a fallback + to show
       the confirmation state. Config comes from the form panel's data attrs. */
    var panel = form.closest('.unvxt-sp-form-panel');
    var KLAVIYO_ENABLED = !panel || panel.getAttribute('data-sp-klaviyo-enabled') !== 'false';
    var KLAVIYO_METRIC = (panel && panel.getAttribute('data-sp-klaviyo-metric')) || 'Applied to Sponsorship';
    var KLAVIYO_KEY = 'TA5kgp';
    var KLAVIYO_REVISION = '2024-10-15';
    var KLAVIYO_EVENTS = 'https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_KEY;

    function fieldVal(name) {
      var el = form.querySelector('[name="contact[' + name + ']"]');
      if (!el) return '';
      if (el.type === 'checkbox') return el.checked ? (el.value || 'Yes') : '';
      return el.value || '';
    }

    /* Values go into the Klaviyo flow "Affiliate application → Discord", which
       templates them into a JSON body server-side (the webhook URL lives in
       Klaviyo, never in this page). Klaviyo does not JSON-escape, so each
       value is made JSON-safe here: line breaks become " / ", straight double
       quotes become curly ones, backslashes and control characters go. Length
       is capped under Discord's 1024-per-field limit (and the 6000 total). */
    function clean(v, n) {
      v = (v || '').toString()
        .replace(/\r\n?|\n/g, ' / ')
        .replace(/"/g, '”')
        .replace(/\\/g, '/')
        .replace(/[\x00-\x1F\x7F]/g, ' ')
        .replace(/\s{2,}/g, ' ')
        .trim();
      return v.length > n ? v.slice(0, n - 1) + '…' : v;
    }

    function sendToKlaviyo() {
      var email = fieldVal('email');
      if (!KLAVIYO_ENABLED || !email || !window.fetch) return Promise.resolve();
      var samples = ['content_sample_1', 'content_sample_2', 'content_sample_3']
        .map(function (n) { return clean(fieldVal(n), 300); })
        .filter(Boolean)
        .join(' · ');
      var props = {
        full_name: clean(fieldVal('full_name'), 200),
        phone: clean(fieldVal('phone'), 60),
        city_state: clean(fieldVal('city_state'), 200),
        applying_as: clean(fieldVal('applying_as'), 200),
        gym_academy: clean(fieldVal('gym_academy'), 200),
        combat_classification: clean(fieldVal('combat_classification'), 200),
        years_training: clean(fieldVal('years_training'), 60),
        competition_history: clean(fieldVal('competition_history'), 1000),
        instagram: clean(fieldVal('instagram'), 200),
        tiktok_youtube: clean(fieldVal('tiktok_youtube'), 200),
        content_sample_1: clean(fieldVal('content_sample_1'), 300),
        content_sample_2: clean(fieldVal('content_sample_2'), 300),
        content_sample_3: clean(fieldVal('content_sample_3'), 300),
        content_samples: samples,
        why_unvext: clean(fieldVal('why_unvext'), 1000),
        referral: clean(fieldVal('referral'), 200),
        age_confirmed: fieldVal('age_confirm') !== '',
        contact_consent: fieldVal('contact_consent') !== ''
      };
      var body = {
        data: {
          type: 'event',
          attributes: {
            properties: props,
            metric: { data: { type: 'metric', attributes: { name: KLAVIYO_METRIC } } },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    sponsorship_applying_as: props.applying_as,
                    sponsorship_combat_classification: props.combat_classification,
                    sponsorship_instagram: props.instagram
                  }
                }
              }
            }
          }
        }
      };
      var post = fetch(KLAVIYO_EVENTS, {
        method: 'POST',
        mode: 'cors',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (window.console) console.log('[unvxt-sp] Klaviyo event HTTP ' + r.status);
      }).catch(function (err) {
        if (window.console) console.error('[unvxt-sp] Klaviyo event failed', err);
      });
      /* Never let a slow/failed Klaviyo call hold up the applicant — cap the wait */
      var timeout = new Promise(function (res) { window.setTimeout(res, 2500); });
      return Promise.race([post, timeout]);
    }

    /* Instant team alert: the application goes to the UNVEXT alerts relay
       (a Cloudflare Worker, alerts-relay/ in the repo), which posts it to
       Discord in about a second. The Discord webhook URL is a secret inside
       the Worker, never in this page. The Worker builds the Discord message
       itself (with @mentions disabled), so raw values are sent here.
       Sent as text/plain so the browser makes a simple request with no CORS
       preflight: the most reliable kind for a keepalive post made while the
       page navigates away on submit. */
    var ALERT_RELAY = 'https://unvext-alerts-relay.unvext-alerts-relay.workers.dev/application';

    function sendToDiscord() {
      if (!window.fetch) return Promise.resolve();
      var payload = {
        email: fieldVal('email'),
        full_name: fieldVal('full_name'),
        phone: fieldVal('phone'),
        city_state: fieldVal('city_state'),
        applying_as: fieldVal('applying_as'),
        gym_academy: fieldVal('gym_academy'),
        combat_classification: fieldVal('combat_classification'),
        years_training: fieldVal('years_training'),
        competition_history: fieldVal('competition_history'),
        instagram: fieldVal('instagram'),
        tiktok_youtube: fieldVal('tiktok_youtube'),
        content_sample_1: fieldVal('content_sample_1'),
        content_sample_2: fieldVal('content_sample_2'),
        content_sample_3: fieldVal('content_sample_3'),
        why_unvext: fieldVal('why_unvext'),
        referral: fieldVal('referral'),
        age_confirmed: fieldVal('age_confirm') !== '',
        contact_consent: fieldVal('contact_consent') !== ''
      };
      var post = fetch(ALERT_RELAY, {
        method: 'POST',
        mode: 'cors',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (window.console) console.log('[unvxt-sp] Alert relay HTTP ' + r.status);
      }).catch(function (err) {
        if (window.console) console.error('[unvxt-sp] Alert relay failed', err);
      });
      /* Same rule as Klaviyo: never hold the applicant hostage to the alert */
      var timeout = new Promise(function (res) { window.setTimeout(res, 2500); });
      return Promise.race([post, timeout]);
    }

    /* Submit: honeypot silently blocks; validate; fire the reliable-capture
       side-effects (Klaviyo + Discord — both keepalive, so they survive the
       page navigation), then let Shopify's NATIVE submit run UNTOUCHED. We must
       NOT preventDefault + programmatically re-submit: that bypasses Shopify's
       spam-protection captcha and the post is rejected with "Missing CAPTCHA
       token". Letting the native submit proceed attaches the captcha token. */
    form.addEventListener('submit', function (e) {
      if (honeypot && honeypot.value !== '') { e.preventDefault(); return; }
      if (submitting) return; /* already handled — let the native submit run */
      if (!form.checkValidity() || !checkboxesOk()) {
        e.preventDefault();
        form.reportValidity();
        return;
      }
      track('form_submit');
      submitting = true;
      sendToKlaviyo();
      sendToDiscord();
      /* Reflect progress AFTER the submit is dispatched — disabling the submit
         button synchronously here would cancel the native submission. */
      window.setTimeout(function () {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting';
      }, 0);
      /* No preventDefault: the native POST (with its captcha token) proceeds. */
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
